import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';

import { CreateEmployerUserContactParams, useAccountsService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';

import { useEmployerUserContactsListQueryKey } from './use-employer-user-contacts-list-query';

function useCreateEmployerUserContact() {
  const accountsService = useAccountsService();
  const queryClient = useQueryClient();
  const employerUserContactListQueryKey = useEmployerUserContactsListQueryKey();

  const { user } = useAuth();

  const mutation = useMutation({
    mutationFn: (params: CreateEmployerUserContactParams) =>
      accountsService.createEmployerUserContact({
        organization_id: user?.organization_id,
        send_invitation_email: true,
        ...params,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: employerUserContactListQueryKey });
    },
  });

  return mutation;
}
export default useCreateEmployerUserContact;
